import axios from "axios";
import store from "@/store";

const apiClient = axios.create({
  baseURL:
    process.env.VUE_APP_API_BASE_URL ||
    "https://api.shamspharmacy.com/api/dashboard",
    //"http://127.0.0.1:8000/api/dashboard",
  headers: {
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use(
  function (config) {
    const token = store.getters["auth_module/currentUser"]?.token;
    const lang = store.getters["lang_module/lang"] || "ar";

    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }

    config.headers.Accept = "application/json";
    config.headers["Accept-language"] = lang;

    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    } else if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default apiClient;
